import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class UsersRepository extends HttpRepository {
    private static readonly RESOURCE = 'users';

    // HERE: data de tipo user
    // TODO: Definir una interfaz para user
    async updateUser(payload): Promise<{ data: any }> {
        return this.patch(
            this.createUri([`${UsersRepository.RESOURCE}`]),
            payload,
            this.createAuthorizationHeader(),
        );
    }

    async validateUsername(user: { customerId: number; username: string }) {
        return this.get(
            `/customers/${user.customerId}/users/${user.username}`,
            this.createAuthorizationHeader(),
        );
    }
}

export const usersRepository = new UsersRepository();
